import { Injectable } from '@angular/core';
import { j2xParser, parse } from 'fast-xml-parser';
import * as _ from 'lodash-es';

export interface Attribute {
  name: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class XMLHelperService {
  attributeNamePrefix = '@_';

  getJsonFromXMLString(svg: string): any {
    const options = {
      attributeNamePrefix: this.attributeNamePrefix,
      ignoreAttributes: false,
      ignoreNameSpace: false,
      allowBooleanAttributes: true,
      supressEmptyNode: true,
    };

    const escaped = this.escapeXmlSpecialChars(svg);
    const result = parse(escaped, options, true);

    return result;
  }

  escapeXmlSpecialChars(xml: string): string {
    return xml.replace(/ < /g, '&lt;').replace(/ > /g, '&gt;');
  }

  getXMLStringFromJson(json: any): string {
    const jsonOptions = {
      ignoreAttributes: false,
      attributeNamePrefix: this.attributeNamePrefix,
      ignoreNameSpace: false,
      allowBooleanAttributes: true,
      format: true,
      indentBy: '  ',
      supressEmptyNode: true,
    };
    const parserJson = new j2xParser(jsonOptions);
    const xmlOutput: string = parserJson.parse(json);

    return xmlOutput;
  }

  addOrUpdateSvgAttributes(xmlJSON: any, attributes: Attribute[]): any {
    const svgJSONCopy = _.cloneDeep(xmlJSON);
    attributes.forEach((a) => (svgJSONCopy.svg[this.attributeNamePrefix + a.name] = a.value));

    return svgJSONCopy;
  }
}
